import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { useGetList } from "react-admin";

export const SubscriptionStats = () => {
  const { data: stats, isLoading } = useGetList("subscriptionStats");
  const { data: limiterStats } = useGetList("limiterStats");

  if (isLoading) {
    return <div>Загрузка статистики...</div>;
  }

  const statsData = stats?.[0] || {};
  const limiterStatsData = limiterStats || [];

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Статистика подписок
      </Typography>

      {/* Общая статистика */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <Card>
            <CardContent>
              <Typography color="textSecondary" gutterBottom>
                Всего планов
              </Typography>
              <Typography variant="h4">{statsData.totalPlans || 0}</Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <Card>
            <CardContent>
              <Typography color="textSecondary" gutterBottom>
                Активных планов
              </Typography>
              <Typography variant="h4" color="primary">
                {statsData.activePlans || 0}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <Card>
            <CardContent>
              <Typography color="textSecondary" gutterBottom>
                Всего подписок
              </Typography>
              <Typography variant="h4">
                {statsData.totalSubscriptions || 0}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <Card>
            <CardContent>
              <Typography color="textSecondary" gutterBottom>
                Активных подписок
              </Typography>
              <Typography variant="h4" color="success.main">
                {statsData.activeSubscriptions || 0}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Статистика по планам */}
      <Card sx={{ mb: 4 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Статистика по планам
          </Typography>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>План</TableCell>
                  <TableCell>Тип</TableCell>
                  <TableCell align="right">Всего подписок</TableCell>
                  <TableCell align="right">Активных</TableCell>
                  <TableCell align="right">Доход</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {statsData.planStats?.map((plan: any) => (
                  <TableRow key={plan.planId}>
                    <TableCell>{plan.planName}</TableCell>
                    <TableCell>
                      <Chip label={plan.planType} size="small" />
                    </TableCell>
                    <TableCell align="right">
                      {plan.totalSubscriptions}
                    </TableCell>
                    <TableCell align="right">
                      <Chip
                        label={plan.activeSubscriptions}
                        color="success"
                        size="small"
                      />
                    </TableCell>
                    <TableCell align="right">
                      ${plan.totalRevenue?.toFixed(2) || "0.00"}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>

      {/* Статистика лимитеров */}
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Статистика лимитеров
          </Typography>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Тип лимитера</TableCell>
                  <TableCell align="right">Общее использование</TableCell>
                  <TableCell align="right">Среднее</TableCell>
                  <TableCell align="right">Максимум</TableCell>
                  <TableCell align="right">На лимите</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {limiterStatsData.map((limiter: any) => (
                  <TableRow key={limiter.limiterType}>
                    <TableCell>
                      <Chip label={limiter.limiterType} size="small" />
                    </TableCell>
                    <TableCell align="right">{limiter.totalUsage}</TableCell>
                    <TableCell align="right">
                      {limiter.averageUsage?.toFixed(1)}
                    </TableCell>
                    <TableCell align="right">{limiter.maxUsage}</TableCell>
                    <TableCell align="right">
                      <Chip
                        label={limiter.usersAtLimit}
                        color={limiter.usersAtLimit > 0 ? "warning" : "default"}
                        size="small"
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </Box>
  );
};
